import styled from 'styled-components'

const FakeInput = styled.div`
  flex: ${(props) => (props.fullHeight ? 1 : undefined)};

  &.error .segment {
    background-color: red;
  }

  & .segment {
    padding: 0.5em;
    min-height: 33px;
    box-shadow: none;
    background-color: whitesmoke;
    min-height: ${(props) => (props.fat ? '60px' : '33px')};
    height: ${(props) => (props.fullHeight ? '100%' : 'auto')};
    overflow: ${(props) => (props.fat || props.full ? 'auto' : null)};
    flex: ${(props) => (props.full ? 1 : null)};
  }

  & .segment .ui.header {
    word-break: break-all;
  }
`

const FakeInputLabel = styled.span`
  font-weight: 700;
  color: black;
`

export { FakeInput, FakeInputLabel }
